import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminProvider } from "./AdminContext";
import { SidebarItemsProvider } from "./SideBarItemsProvider";
import { AuthProvider } from "./AuthContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OrgsProvider } from "./OrgsProvider";
import { ChatProvider } from "./ChatProvider";

import type { ReactNode } from "react";


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});

export default function Providers({ children }: { children: ReactNode }) {
    return (
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <OrgsProvider>
                    <AdminProvider>
                        <ChatProvider>
                            <SidebarProvider>
                                <SidebarItemsProvider>
                                    {children}
                                </SidebarItemsProvider>
                            </SidebarProvider>
                        </ChatProvider>
                    </AdminProvider>
                </OrgsProvider>
            </AuthProvider>
        </QueryClientProvider>
    );
}
